import _objectSpread from "E:\\xinyongban\\xinyidai-frontend\\node_modules\\@babel\\runtime-corejs2/helpers/esm/objectSpread";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "E:\\xinyongban\\xinyidai-frontend\\node_modules\\@babel\\runtime-corejs2/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { selectDemandListByCondition, updateStatusById, listByDemandId, save } from '@/api/ydm';
export default {
  name: 'FinanceDetail',
  props: {
    getSourceType: String
  },
  data: function data() {
    return {
      belongAreaArr: [{
        id: 1,
        label: '已受理'
      }, {
        id: 2,
        label: '未受理'
      }],
      ckDialog: false,
      //查看操作
      fkDialog: false,
      addDialog: false,
      //新增
      ckDialogList: [],
      form: {
        demandNo: '',
        //需求编号
        status: '',
        //受理状态
        enterpriseName: '',
        //企业名称
        enterpriseCode: '',
        //统一社会信用代码
        bankCode: '',
        //意向银行代码
        page: 1,
        pageSize: 10
      },
      detailForm: {},
      detailForm2: {
        demandId: '',
        //需求id
        demandNo: '',
        //需求编号
        operateContent: '' //操作内容

      },
      demandId: '',
      //需求id
      registereFrom: {},
      applyProList: [],
      total: 0,
      total2: 0,
      form2: {
        page: 1,
        pageSize: 5
      }
    };
  },
  mounted: function mounted() {
    this.getcheckinListList();
  },
  methods: {
    submitDialog: function submitDialog() {
      var _this = this;

      save(this.detailForm2).then(function (res) {
        if (res.data.code == 200) {
          _this.$message.success(res.data.msg);

          _this.addDialog = false;
        } else {
          _this.$message.error(res.data.msg);
        }
      });
    },
    lookGan: function lookGan(row) {
      var _this2 = this;

      this.demandId = row.id;
      listByDemandId({
        demandId: row.id,
        page: 1,
        pageSize: this.form2.pageSize
      }).then(function (res) {
        console.log(res);

        if (res.data.code == 200) {
          _this2.ckDialogList = res.data.data.list;
          _this2.total2 = res.data.data.total;
          _this2.ckDialog = true;
        } else {
          _this2.$message.error(res.data.msg);
        }
      });
    },
    addDialogF: function addDialogF(row) {
      this.detailForm2.demandId = row.id;
      this.detailForm2.demandNo = row.demandNo;
      this.detailForm2.operateContent = '';
      this.addDialog = true;
    },
    fanye: function fanye() {
      var _this3 = this;

      listByDemandId({
        demandId: this.demandId,
        page: this.form2.page,
        pageSize: this.form2.pageSize
      }).then(function (res) {
        if (res.data.code == 200) {
          _this3.ckDialogList = res.data.data.list;
          _this3.total2 = res.data.data.total;
        } else {
          _this3.$message.error(res.data.msg);
        }
      });
    },
    fkInformation: function fkInformation(row) {
      this.fkDialog = true;
    },
    detailLook: function detailLook(row) {
      var _this4 = this;

      this.$confirm("\u786E\u5B9A\u8981\u53D7\u7406\u5417?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(
      /*#__PURE__*/
      _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                updateStatusById({
                  id: row.id
                }).then(function (res) {
                  if (res.data.code == 200) {
                    _this4.$message.success("受理成功");

                    _this4.getcheckinListList();
                  }
                });

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      })));
    },
    // 查询
    queryInfo: function queryInfo() {
      this.form.page = 1;
      this.getcheckinListList();
    },
    getcheckinListList: function () {
      var _getcheckinListList = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee2() {
        var _this5 = this;

        var searchForm;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                searchForm = _objectSpread({}, this.form, {
                  bankCode: '' // 金融机构+信用办

                });
                selectDemandListByCondition(searchForm).then(function (res) {
                  if (res.data.code == 200) {
                    _this5.applyProList = res.data.data.list;
                    _this5.total = res.data.data.total;
                  } else {
                    _this5.$message.error(res.data.msg);
                  }
                });

              case 2:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function getcheckinListList() {
        return _getcheckinListList.apply(this, arguments);
      }

      return getcheckinListList;
    }(),
    handleCurrentChange: function handleCurrentChange(val) {
      this.form.page = val;
      this.getcheckinListList();
    },
    handleCurrentChange2: function handleCurrentChange2(val) {
      this.form2.page = val;
      console.log(val);
      this.fanye();
    }
  }
};